import {
  lcmApiClient,
  packSubscription,
  backendApiClient,
} from "lcm-iot-commons";
import { extractServiceSubscriptions } from "../extractors/serviceSubscriptionsExtractor";
import {
  extractConnectSubscription,
  extractConnectSubscriptions,
  extractCurrentSubscription,
} from "../extractors/connectSubscriptionsExtractor";
import { extractAssets } from "../extractors/assetsExtractor";

/* istanbul ignore next */
export async function loadServiceSubscriptions(parameters: $TSFixMe) {
  const filter = {
    include: "specifications",
    ...parameters,
  };

  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().getAll("/subscriptions", filter);
  return extractServiceSubscriptions(response);
}

/* istanbul ignore next */
export async function loadServiceSubscriptionAssets(
  id: $TSFixMe,
  parameters: $TSFixMe,
) {
  // this method is at the moment only relevant for smart systems subscriptions.
  // Thats the reason why we do not take care if their are more than 25 assets available for the subscription
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().get(
    `/subscriptions/${id}/assets`,
    parameters,
  );
  return extractAssets(response);
}

/* istanbul ignore next */
export async function loadConnectSubscriptions(parameters: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().get("/api_subscriptions", parameters);
  return {
    connectSubscriptions: extractConnectSubscriptions(response),
    totalCount: (response as $TSFixMe).pagination.total_count,
    nextPageUrl: (response as $TSFixMe).pagination.next,
  };
}
/* istanbul ignore next */
export async function loadConnectSubscription(id: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 1.
  const response = await lcmApiClient(false).get(`/api_subscriptions/${id}`);
  return extractConnectSubscription(response);
}

/* istanbul ignore next */
export async function patchConnectSubscriptionAddress(
  id: $TSFixMe,
  customerPurchaseOrder: $TSFixMe,
  billingAddress: $TSFixMe,
  shippingAddress: $TSFixMe,
) {
  await lcmApiClient().patch(
    `/api_subscriptions/${id}`,
    packSubscription(customerPurchaseOrder, billingAddress, shippingAddress),
  );
  await backendApiClient(false).patch(
    `/api_subscriptions/${id}/update_billing_details`,
    packSubscription(customerPurchaseOrder, billingAddress, shippingAddress),
  );
}

/* istanbul ignore next */
export async function loadNextConnectSubscriptions(url: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 1.
  const response = await lcmApiClient().get(url);
  return {
    connectSubscriptions: extractConnectSubscriptions(response),
    totalCount: (response as $TSFixMe).pagination.total_count,
    nextPageUrl: (response as $TSFixMe).pagination.next,
  };
}

/* istanbul ignore next */
export async function loadCurrentSubscription(
  id: $TSFixMe,
  paymentDetails = false,
  generateAdvancedInvoiceIfNeeded = false,
) {
  let parameters = paymentDetails ? { include: "payment_details" } : {};
  parameters = generateAdvancedInvoiceIfNeeded
    ? // @ts-expect-error TS(2322) FIXME: Type '{ include: string; } | { include?: undefined... Remove this comment to see the full error message
      { ...parameters, generate_advanced_invoice_if_needed: "true" }
    : parameters;
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await backendApiClient(false).get(
    `/subscriptions/${id}`,
    parameters,
  );
  return extractCurrentSubscription(response);
}
